module.exports = __webpack_public_path__ + "img/car-steering-wheel.6e7ab593.png";